// extends basic product slider but relies on API endpoint for its products so needs to take some extra steps during setup and init
// it relies a lot on side effects to reduce verbosity in JS setup

import { ProductSlider } from "./ClassProductSlider";

export class RelatedProductSlider extends ProductSlider {
	constructor(el) {
		super(el);
		this.currencyFormatter = new Intl.NumberFormat("en-US", {
			style: "currency",
			currency: "USD",
		});
	}

	init() {
		this.productUrl = this.el.dataset.productUrl;

		// clone our card template and then remove it from the product area
		this.cardTemplate = this.productArea
			.querySelector("#product-card-template")
			.cloneNode(true);
		this.cardTemplate.removeAttribute("id");
		this.productArea.innerHTML = "";

		// fetch products
		fetch(this.productUrl)
			.then((res) => res.json())
			.then((recData) => {
				this.initializeProducts(recData.products);
			})
			.catch((err) => {
				console.error(err);
			});
	}

	// set up products cards
	initializeProducts(products) {
		// create each card and add to product area
		products.forEach((p) => {
			const c = this.cardTemplate.cloneNode(true);

			const title = c.querySelector("h3");
			const price = c.querySelector(".price");
			const inner = c.querySelector(".product-card");
			const img = c.querySelector("img");
			inner.classList.add("visible");
			c.setAttribute("href", p.url);
			img.setAttribute("src", p.featured_image);
			title.innerText = p.title;
			// divide by 100 to convert to dollars and cents
			price.innerText = this.currencyFormatter.format(p.price / 100);
			this.productArea.appendChild(c);
		});

		// update products array
		this.products = Array.from(
			this.productArea.querySelectorAll(".product-card")
		);

		// update slide count
		this.slideCount = this.products.length;

		// call init on product slider class
		super.init();
	}
}
